// extracted by mini-css-extract-plugin
export var image = "dl_dl";